module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"id":"/opt/build/repo/blog/src/pages/2018-03-30-crushing-it/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Breve resumen de \"Crushing it !\"","date":"March 30, 2018","path":"/crushing-it","tags":["Gary Vaynerchuk","entrepreneurship"],"excerpt":"Cómo utilizar los mismos trucos y herramientas que los grandes emprendedores utilizan para construir sus negocios y tener influencia."}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 334
// module chunks = 142629428675168